<template>
	<div>
		<v-data-table
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			:server-items-length="totalItens"
			item-key="id"
			:options="paginacaoInterna"
			no-data-text="Não há atas cadastradas"
			hide-default-footer
			class="arp-listview row-pointer"
		>
			<template #item.numeroProcesso="{ item }">
				<span>{{ item.numeroProcesso | semProcessoFilter }}</span>
			</template>
			<template #item.numeroEdital="{ item }">
				<span v-if="item.numeroEdital"> {{ item.numeroEdital }}</span>
				<span v-else>---</span>
			</template>
			<template #item.numeroAta="{ item }">
				<div class="d-flex">
					<div style="width: 15px" v-if="item.isAtaProrrogadaLegado || item.isAtaProrrogada">
						<icone-ata-prorrogada :fim-validade="item.fimValidade"></icone-ata-prorrogada>
					</div>
					<texto-tooltip
						class="ml-2"
						:texto="item.numeroAta | numeroAtaFilter(isNumeroAtaManual)"
						:tamanho-maximo="30"
					></texto-tooltip>
				</div>
			</template>
			<template #item.descricao="{ item }">
				<texto-tooltip :texto="item.descricao" :tamanho-maximo="50"></texto-tooltip>
			</template>
			<template #item.fimValidade="{ item }">
				<icone-relogio :fim-validade="item.fimValidade" :inicioValidade="item.inicioValidade"></icone-relogio>
			</template>
			<template #item.orgao="{ item }">
				<span> {{ item.orgao | semProcessoFilter }}</span>
			</template>
			<template #item.pedidos="{ item }">
				<div v-if="!item.isLegado">
					<span class="pr-2"> {{ item.numeroPedidosDaAta }}</span>
					<v-chip
						v-if="item.numeroPedidosAhReceber"
						text-color="white"
						small
						color="green"
						@click="acessarPedido(item.id)"
					>
						{{ '+ ' + item.numeroPedidosAhReceber + ' novos' }}
					</v-chip>
				</div>
				<div v-else>
					<span>---</span>
				</div>
			</template>
			<template #item.situacao="{ item }">
				<span>
					{{ item.situacao | situacaoFilter(situacoesAta) }}

					<icone-tooltip
						v-if="estaCancelado(item)"
						icone="mdi-close-circle-outline"
						cor="red"
						:texto="item.justificativaCancelamento"
						tamanho="16px"
					></icone-tooltip>

					<icone-tooltip
						v-if="item.isBloqueado"
						icone="mdi-cancel"
						cor="red"
						texto="Ata está bloqueada."
						tamanho="16px"
					></icone-tooltip>
				</span>
			</template>
			<template #item.acoes="{ item }">
				<ata-listagem-botoes-acoes
					:ata="item"
					@abrir-modal-orgaos-participantes="abrirFecharModalOrgaosParticipantes"
				></ata-listagem-botoes-acoes>
			</template>
		</v-data-table>
		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="resetarPage"
		></paginacao-tabela>

		<template-listagem-vazia :textos="textos" :total-itens="totalItens"></template-listagem-vazia>

		<modal-orgaos-participantes
			v-if="exibirModalOrgaosParticipantes"
			:exibir="exibirModalOrgaosParticipantes"
			:id-ata="idAtaModalOrgaosParticipantes"
			@fechar-modal="abrirFecharModalOrgaosParticipantes"
		></modal-orgaos-participantes>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import tabelaMixin from '@/views/mixins/tabela'
import AtaListagemBotoesAcoes from '@/views/pages/ata/pesquisa/listagem/botoes-acoes/AtaListagemBotoesAcoes.vue'
import { actionTypes, routesNames, situacoes } from '@/core/constants'
import IconeAtaProrrogada from '@/views/components/icones/IconeAtaProrrogacao.vue'
import ModalOrgaosParticipantes from '@/views/pages/ata/pesquisa/listagem/modal-orgaos-participantes/ModalOrgaosParticipantes.vue'

export default {
	name: 'atas-listagem',
	components: { ModalOrgaosParticipantes, IconeAtaProrrogada, AtaListagemBotoesAcoes },
	mixins: [tabelaMixin],
	props: {
		itens: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			colunas: [
				new TabelaColunaUtils('Nº Ata', 'numeroAta', '13%'),
				new TabelaColunaUtils('Processo', 'numeroProcesso', '10%'),
				new TabelaColunaUtils('Nº Edital', 'numeroEdital', '10%'),
				new TabelaColunaUtils('Descrição', 'descricao', '28%'),
				new TabelaColunaUtils('Órgão Gerenciador', 'orgao', '10%'),
				new TabelaColunaUtils('Situação', 'situacao', '10%'),
				new TabelaColunaUtils('Fim Validade', 'fimValidade', '10%'),
				new TabelaColunaUtils('Pedidos', 'pedidos', '20%'),
				new TabelaColunaUtils('Ações', 'acoes', '5%'),
			],
			paginacaoInterna: this.paginacao,
			textos: {
				titulo: 'Não foram encontradas atas',
			},
			situacoesAta: situacoes.ATA,
			idAtaModalOrgaosParticipantes: null,
			exibirModalOrgaosParticipantes: false,
		}
	},
	computed: {
		isNumeroAtaManual() {
			return this.$store.state.parametrosSistema.numeroDaAtaIsManual
		},
	},
	methods: {
		resetarPage() {
			this.$emit('resetar-page')
		},
		async acessarPedido(idAta) {
			const informacoesAta = await this.$store.dispatch(actionTypes.ATA.BUSCAR_POR_ID, idAta)

			if (
				informacoesAta.usuarioPodeVisualizarPedido ||
				informacoesAta.usuariosPodeCriarPedido ||
				informacoesAta.usuarioPermissaoAlterar
			) {
				this.$router.push({
					name: routesNames.ATA.ATA_ACESSAR_GESTAO_PEDIDO_VIEW,
					params: { id: idAta },
				})
			} else {
				this.mostrarNotificacaoWarning('Usuário sem permissão de acesso.')
			}
		},
		abrirFecharModalOrgaosParticipantes(idAta) {
			this.idAtaModalOrgaosParticipantes = Number(idAta)
			this.exibirModalOrgaosParticipantes = !this.exibirModalOrgaosParticipantes
		},
		estaCancelado(item) {
			return item.situacao === situacoes.ATA.CANCELADO.value
		},
	},
}
</script>

<style scoped lang="stylus">
.pr-tabela-todos-atas td:hover
	cursor pointer !important

@media (max-width: 720px)
	.pr-tabela-todos-atas
		td:nth-of-type(1):before
			content "Nº Ata:"

		td:nth-of-type(2):before
			content "Processo:"

		td:nth-of-type(3):before
			content "Descrição:"

		td:nth-of-type(4):before
			content "Órgão Gerenciador:"

		td:nth-of-type(5):before
			content "Situação:"

		td:nth-of-type(6):before
			content "Fim Validade:"

		td:nth-of-type(7):before
			display none
</style>
